<iframe #embeddedNectaClientFrame sandbox="allow-scripts allow-same-origin allow-forms allow-popups" width="100%" height="100%"></iframe>